import CustomSourceFlowText from "@/components/Shared/CustomSourceflowText";
import ExpandingButton from "@/components/Buttons/ExpandingButton";
import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import teamImg from "@/assets/team/team-join.png";
import Link from "next/link";
import useLocale from "@/hooks/useLocale";
import localizePath from "@/functions/localizePath";

export default function BlogContentJoin({ content: { title, info }, path }) {
  const locale = useLocale();

  return (
    <div className={`relative 3xl:max-w-none w-full z-10`}>
      <SourceFlowImage
        src={teamImg ?? ""}
        size="1678x610"
        alt="team"
        className="absolute object-cover w-full h-full"
      />
      <div className="relative py-[30px] px-[30px] md:py-[120px] mx:px-12 max-w-[700px]">
        <h2 className="text-3xl sm:text-[40px] xl:text-[50px]/[60px] mb-6">
          <CustomSourceFlowText
            title={title}
            path={`dynamic1.${path}.header1`}
            locale={locale}
          />
        </h2>
        <p className="text-base sm:text-xl/[30px] mb-12">
          <CustomSourceFlowText
            title={info}
            path={`dynamic1.${path}.text1`}
            locale={locale}
          />
        </p>
        <div className="flex items-center flex-wrap xl:mt-4 lg:mt-0 gap-10">
          <ExpandingButton
            url={localizePath("/jobs", locale)}
            color="white"
            bgColor="transparent"
            hoverBGColor="white"
            hoverColor="#1B0D34"
          >
            <CustomSourceFlowText
              title="Search Jobs"
              path={`dynamic1.${path}.primaryBtn`}
              locale={locale}
            />
          </ExpandingButton>
          <div className="text-white group w-max flex items-center">
            <Link
              className="text-white text-base sm:text-xl text-center  group text-decoration-none group-hover:text-white secondary--btn"
              href={localizePath("/vacancies", locale)}
            >
              <CustomSourceFlowText
                title="Find Talent"
                path={`dynamic1.${path}.secondBtn`}
                locale={locale}
              />
              <span className="w-0 bg-white h-[1px] transition-all block group-hover:w-full mt-[-6px]" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
